import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Moment from 'moment';
import { getActiveLanguage } from '@haldor/ui';
import './time_picker.scss';

var TimePicker = /*#__PURE__*/function (_Component) {
  _inherits(TimePicker, _Component);

  var _super = _createSuper(TimePicker);

  function TimePicker(props) {
    var _this;

    _classCallCheck(this, TimePicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onMinutesFocus", function () {
      _this.refs['minute'].select();
    });

    _defineProperty(_assertThisInitialized(_this), "onHourFocus", function () {
      _this.refs['hour'].select();
    });

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (event) {
      var timeString = event.target.value;
      var split = timeString.split(':');

      if (split.length === 2 && _this.props.time) {
        var newTime = Moment(_this.props.time).set('hour', split[0]).set('minute', split[1]);

        _this.props.onChange(newTime);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onHourChange", function (event) {
      var hours = event.target.value;

      if (parseInt(hours) < 0) {
        hours = 0;
      }

      if (parseInt(hours) > 23) {
        hours = 23;
      }

      if (hours.length > 1) {
        _this.refs['minute'].focus();
      }

      if (parseInt(hours) < 10) {
        hours = '0' + hours;
      }

      var newTime = Moment(_this.props.time).set('hour', hours);

      _this.props.onChange(newTime);
    });

    _defineProperty(_assertThisInitialized(_this), "onMinutesChange", function (event) {
      var minutes = event.target.value;

      if (minutes.length == 3) {
        event.target.select();
      }

      if (parseInt(minutes) < 0) {
        minutes = 0;
      }

      if (parseInt(minutes) > 59) {
        minutes = 59;
      }

      if (parseInt(minutes) < 10) {
        minutes = '0' + minutes;
      }

      var newTime = Moment(_this.props.time).set('minutes', minutes);

      _this.props.onChange(newTime);
    });

    _defineProperty(_assertThisInitialized(_this), "toggleAmPm", function () {
      var newTime = null;

      if (Moment(_this.props.time).format('A') == 'AM') {
        newTime = Moment(_this.props.time).add(12, 'hours');
      } else {
        newTime = Moment(_this.props.time).subtract(12, 'hours');
      }

      _this.props.onChange(newTime);
    });

    Moment.locale(getActiveLanguage());
    return _this;
  }

  _createClass(TimePicker, [{
    key: "render",
    value: function render() {
      var format = this.props.twelve ? 'hh' : 'HH';
      var hours = this.props.time ? Moment(this.props.time).format(format) : Moment().format(format);
      var minutes = this.props.time ? Moment(this.props.time).format('mm') : Moment().format('mm');
      return /*#__PURE__*/React.createElement("div", {
        className: "time-picker form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "time-picker-container"
      }, /*#__PURE__*/React.createElement("input", {
        className: "time-part",
        type: "text",
        onChange: this.onHourChange,
        onFocus: this.onHourFocus,
        value: hours,
        ref: "hour"
      }), /*#__PURE__*/React.createElement("span", null, ":"), /*#__PURE__*/React.createElement("input", {
        className: "time-part",
        type: "text",
        onChange: this.onMinutesChange,
        onFocus: this.onMinutesFocus,
        value: minutes,
        ref: "minute"
      }), this.props.twelve ? /*#__PURE__*/React.createElement("span", {
        className: "time-switcher",
        onClick: this.toggleAmPm
      }, Moment(this.props.time).format('A')) : null));
    }
  }]);

  return TimePicker;
}(Component);

function mapStateToProps(state) {
  return {
    languages: state.Languages.languages
  };
}

export default connect(mapStateToProps, {})(TimePicker);